export const WIZARD_STEPS = 6;
export const APP_DEFAULT_PATH = '/home';

/** Day-range toggle options for collaboration metrics (stacked charts) */
/** and for KPI cards and GraphQL merchant stats. */
export const COLLABORATION_DAY_OPTIONS = [7, 28];

/** Max daily buckets kept when parsing `tts_txdata_record` stacked series from merchant metadata. */
export const COLLABORATION_METRICS_MAX_DAYS = 28;
export const SERIES_KPIS_DAY_OPTIONS = [7, 28, 90];
